module.exports = __webpack_public_path__ + "static/media/banc-metro.9029ffe8.png";